export class ImportIndustryProductsDiscountsResult {
  private messageResult: string;

  getMessageResult(): string {
    return this.messageResult;
  }

  setMessageResult(value: string): void {
    this.messageResult = value;
  }
}
